import React, { useState, useEffect } from 'react';
import { createGlobalStyle } from 'styled-components';
import { navigationContext } from './../context';
import { useParams } from 'react-router-dom';

const GlobalStyle = () => {
    const [color, setColor] = useState("#000000");
    const [fontColor, setFontColor] = useState("#ffffff");
    const [svgColor, setSvgColor] = useState("#ffffff");
    const [logo, setLogo] = useState(null);
    const [backGroundColor, setBackGroundColor] = useState("#ffffff");
    const [helio, setHelio] = useState(null);
    const { helioUrl } = useParams();


    const GlobalStyles = createGlobalStyle
    `
    h1 {
        background-color: ${color};
        color: ${fontColor};
    }

    .button.pdvGrayed {
        background-color: ${backGroundColor};
        color: ${fontColor};

        svg {
            fill: ${svgColor};
        }
    }

    .pdvNormal:hover {
        background-color: ${backGroundColor};
        color: ${svgColor};

        svg {
            fill: ${svgColor};
        }
    }
    `
    const getYiq = (color) => {
        let r = parseInt(color.substring(1, 3), 16);
        let g = parseInt(color.substring(3, 5), 16);
        let b = parseInt(color.substring(5, 7), 16);

        let yiq = ((r * 299) + (g * 587) + (b * 114)) / 1000;
        return yiq;
    }

    const ColorHandler = (color, secondaryColor, backGroundColor) => {
        if (secondaryColor && secondaryColor !== "") {
            setFontColor(secondaryColor);
        } else {
            getYiq(color) >= 128 ? setFontColor("#000000") : setFontColor("#ffffff");
        }
        getYiq(color) >= 128 ? setSvgColor("#505050") : setSvgColor("#ffffff");

        setColor(color);
        setBackGroundColor(backGroundColor);
    }

    const LogoHandler = (logo) => {
        setLogo(logo);
    }

    useEffect(() => {
        setHelio(helioUrl);
    }, [helioUrl]);

    useEffect(() => {
        if (helio) {
            fetch(`/helio/${helio}/programme.json`, { mode: 'cors' })
                .then(response => response.json())
                .then(datas => {
                    ColorHandler(datas.generals[0].color, datas.generals[0].fontColor, datas.generals[0].backGroundColor);
                })
                .catch(error => console.log(error));
        }
    }, [helio]);

    return (
        <navigationContext.Provider value={{ helio: helio }}>
            <GlobalStyles />
        </navigationContext.Provider>
    )

}

export default GlobalStyle; 